export default __webpack_public_path__ + "static/media/login_view_image.b7dff9bd.jpg";